<template>
  <v-list-group
    style="max-height: 50vh; overflow-y: auto"
    prepend-icon=""
    color="white"
    no-action
  >
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title class="h6 font-weight-bold text-wrap"
                           style="color: white"
                           v-text="collection.title"></v-list-item-title>
      </v-list-item-content>
    </template>
    <slot></slot>
  </v-list-group>
</template>

<script>
export default {
  name: 'Collection',

  props: {
    collection: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>

</style>
